import { Box, Tabs, Tab, TextField, Typography, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import SearchIconLg from '../../assets/Icons/SearchIcon';
import AddIcon from '@mui/icons-material/Add';
import MUICancelButton from '../../reusable_components/components/MuiCancelButton';
import CandidateReferrals from './CandidateReferrals';
import ClientReferrals from './ClientReferrals';
import JobReferrals from './JobReferrals';
import NewReferrals from './NewReferrals';


const Referrals = () => {

    const [activeTab, setActiveTab] = useState(() => {
        return Number(localStorage.getItem('referralsTab')) || 0; // Retrieve stored tab index
    });

    const [search, setSearch] = useState("");


    const onChangeSearchbar = (event) => {
        const newSearch = event.target.value // Update the search for the active tab
        setSearch(newSearch);
    };



    const handleTabChange = (event, newValue) => {
        localStorage.setItem('referralsTab', newValue);
        setActiveTab(newValue);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 0:
                return <NewReferrals search={search} />;
            // case 1:
            //     return <CandidateReferrals search={search} />;
            case 1:
                return <ClientReferrals search={search} />;
            case 2:
                return <JobReferrals search={search} />;
            default:
                return null;
        }
    };

    return (
        <Box className="container">
            {/* Header Section */}
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
                <Box>
                    <Typography className="title">Referrals</Typography>
                </Box>
                {
                     (activeTab === 1 || activeTab === 2) && (
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    sx={{ display: 'flex', flexDirection: 'row', gap: '20px' }}
                >
                    <TextField
                        placeholder="Search "
                        className="textfields1"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" sx={{ marginRight: '5px' }}>
                                    <SearchIconLg width={20} height={20} />
                                </InputAdornment>
                            ),
                        }}
                        value={search}
                        onChange={onChangeSearchbar}
                    />

                    {/* <MUICancelButton
                        title="Add Referral"
                        sx={{ border: '1px solid #7F56D9', color: '#ffffff', backgroundColor: '#7F56D9', width: '150px' }}
                        startIcon={<AddIcon />}
                    ></MUICancelButton> */}
                </Box>
                    )
                }
            </Box>

            {/* Tabs Section */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '10px' }}>
                <Tabs value={activeTab} onChange={handleTabChange}
                    textColor="primary"
                    indicatorColor="secondary"
                >
                    <Tab
                        label="New referrals"
                        className="tabs"
                        sx={{ textTransform: 'none', color: activeTab === 0 ? '#7F56D9' : '#475467', fontWeight: 600 }}
                    />
                    {/* <Tab 
                        label="Candidates" 
                        sx={{ textTransform: 'none', color: activeTab === 1 ? '#7F56D9' : '#475467', fontWeight: 600 }} 
                    /> */}
                    <Tab
                        label="Client"
                        className="tabs"
                        sx={{ textTransform: 'none', color: activeTab === 1 ? '#7F56D9' : '#475467', fontWeight: 600 }}
                    />
                    <Tab
                        label="Job positions"
                        className="tabs"
                        sx={{ textTransform: 'none', color: activeTab === 2 ? '#7F56D9' : '#475467', fontWeight: 600 }}
                    />
                </Tabs>
            </Box>

            {/* Tab Content Section */}
            <Box>
                {renderTabContent()}
            </Box>
        </Box>
    );
};

export default Referrals;
